import * as React from 'react';
import { PageTitle } from '../../components/PageTitle';
import { useSelector } from 'react-redux';
import { newbuildingDisplayNameSelector, newbuildingUrlSelector } from '../../selectors';
export const PageTitleContainer = (): React.JSX.Element => {
  const newbuildingName = useSelector(newbuildingDisplayNameSelector);
  const newbuildingUrl = useSelector(newbuildingUrlSelector);

  return <PageTitle newbuildingName={newbuildingName} newbuildingUrl={newbuildingUrl} />;
};
